import {CommonService} from '../../../shared/utils/common.service';
import {UtilsService} from '../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';
import {ITanquerosResp} from '../modelos/ITanquerosRes';

@Injectable({
  providedIn: 'root'
})

export class TanqueroService {

  private diccionarioModulo: any;
  private urlBalanzApi: string;
  private urlMaestros : string;

  constructor(private _util: UtilsService, private _commom: CommonService){
    this.diccionarioModulo = moduloGaritas;
    this.urlBalanzApi = this._util.getUrlBascula();
    this.urlMaestros  = this._util.getDatosMaestros();
  }

  obtener(): Observable<any[]> {
    return this._commom.peticionGetConHeader(
      this.urlBalanzApi + this.diccionarioModulo.url.tanqueros.obtenerTodo
    );
  }

  obtenerPorId(idGarita: number): Observable<any> {
    return this._commom.peticionGetConHeader(
      this.urlBalanzApi+
      this.diccionarioModulo.url.tanqueros.obtenerPorId + idGarita
    );
  }

  crear(request: any) {
    return this._commom.peticionPostConHeader(
      this.urlBalanzApi+ this.diccionarioModulo.url.tanqueros.crear,
      request
    );
  }

  editar(request: any) {
    return this._commom.peticionPutConHeader(
      this.urlBalanzApi+ this.diccionarioModulo.url.tanqueros.actualizar,
      request
    );
  }

  borrar(idTanquero: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.urlBalanzApi + this.diccionarioModulo.url.tanqueros.eliminar + idTanquero
    );
  }

}
